import { SourcingService } from 'api-clients/monolith';

type DashboardOpeningsQueryParams = {
  selectedForSourcing?: boolean;
  page?: number;
  perPage?: number;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  query?: string;
  positionIds?: string[];
  locationIds?: string[];
  showAggregateData?: boolean;
  brandIds?: string[];
};

export function getDashboardOpenings(params: DashboardOpeningsQueryParams) {
  return SourcingService.getInternalApiSourcingDashboardOpenings(
    params.selectedForSourcing,
    params.page,
    params.perPage,
    params.sortBy,
    params.sortDirection,
    params.query,
    params.positionIds,
    params.locationIds,
    params.showAggregateData,
    params.brandIds,
  );
}
